var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.53842 1.73156C5.69565 1.28734 6.32388 1.28734 6.48111 1.73156L7.39184 4.30457C7.46252 4.50426 7.65136 4.63774 7.86319 4.63774H10.6187C11.0875 4.63774 11.2986 5.22487 10.9371 5.52332L8.94351 7.1691C8.79985 7.2877 8.73403 7.47633 8.77273 7.65855L9.37387 10.4891C9.46421 10.9145 9.00594 11.2445 8.63115 11.0239L6.26339 9.63026C6.10686 9.53813 5.91267 9.53813 5.75614 9.63026L3.38838 11.0239C3.01359 11.2445 2.55532 10.9145 2.64566 10.4891L3.2468 7.65855C3.2855 7.47633 3.21969 7.2877 3.07603 7.1691L1.08248 5.52332C0.720962 5.22487 0.932002 4.63774 1.4008 4.63774H4.15635C4.36817 4.63774 4.55701 4.50426 4.62769 4.30457L5.53842 1.73156Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8418b8ef5990ed4319301c5fe3a13f20.svg";
export { ForwardRef as ReactComponent };